import { connect } from "react-redux";
import { createQuestions, fetchQuestions } from "../store/action";
import {
  CreateQuestionInput,
  QuationProps,
  QuestionInput,
  stateStatusType,
} from "../store/actionType";
import { FormEvent, useEffect, useState } from "react";
import { ApiError } from "components";
import Questionnarie from "./components/QuestionForm";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";

interface OwnProps {
  onClose: () => void;
  videoData: VideoDetailProps
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & OwnProps;
const HandleCreateQuestion: React.FC<Props> = ({
  onCreateQuestion,
  onClose,
  videoData,
  fetchQuestions
}) => {
  const [submitted, setSubmitted] = useState(false);
  const [questions, setQuestions] = useState<QuestionInput[]>([]);
  const [apiError, setApiError] = useState<string | null>(null);
  const [isValid, setIsValid] = useState(false);
  const handleChange = (qs: QuestionInput[], valid: boolean) => {
    setQuestions(qs);
    setIsValid(valid);
  };
  const handleSubmit = async (e: FormEvent) => {
     e.preventDefault();
    const input = {
      video_id:videoData.id.toString(),
      questions: questions
    }
    if (!isValid || questions.length === 0) {
      setApiError("Please fill all required fields correctly.");
      return;
    }
     setSubmitted(true);
    if(isValid && questions.length !== 0){
      onCreateQuestion(input)
    }
  };
  useEffect(() => {
    if (!submitted) return;

    if (fetchQuestions.isLoading) return;

    if (fetchQuestions.status === stateStatusType.SUCCESS) {
      setApiError(null);
      onClose(); 
    }

    if (fetchQuestions.status === stateStatusType.FAILED) {
      setApiError(fetchQuestions.error || "Failed to create questions.");
    }

    setSubmitted(false); 
  }, [fetchQuestions, submitted]);
  return (
    <>
      <Questionnarie
        onChange={handleChange}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapStateToProps = (state: any) => ({
  fetchQuestions: state.questions?.genericQuestionsState,
});
const mapDispatchToProps = (dispatch: any) => ({
  onCreateQuestion: (input: CreateQuestionInput) =>
    dispatch(createQuestions(input)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleCreateQuestion);
